import { formatNumeral, unformatNumeral } from "cleave-zen";

export default function initCleave() {
    const NumeralInputs = document.querySelectorAll(
        'input[data-cleave="format"]'
    );

    NumeralInputs.forEach((element) => {
        element.setAttribute("inputmode", "numeric");

        if (element.value) cleaverFormat(element);

        element.addEventListener("input", (e) => {
            cleaverFormat(element);
        });
    });

    function cleaverFormat(element) {
        let elementSibling = element.nextElementSibling;
        let cleaveParameters = {
            numeral: true,
            numeralDecimalMark: ",",
            delimiter: ".",
        };

        if (element.getAttribute("data-cleave-prefix"))
            cleaveParameters.prefix =
                element.getAttribute("data-cleave-prefix");

        let cleaveValue = formatNumeral(element.value, cleaveParameters);

        let realValue = unformatNumeral(cleaveValue).replace(/[.\s]/g, "");

        element.value = cleaveValue;

        if (elementSibling.getAttribute("data-cleave") == "unformat")
            elementSibling.value = realValue;

        if (!realValue) {
            element.value = "";
        }
    }
}
